import * as R from '../../../routes';
import { MODES } from '../../components/CycleCreate/CycleCreateContent';
import replacement from '../Replacement';
import { interpolateAppUrl } from '../Url';
import { hasBasicHr, isManager } from '../User';

const FEEDBACK = 'FEEDBACK';
const REVIEW = 'REVIEW';
const OBJECTIVE = 'OBJECTIVE';

export function getUrl(user, cycle) {
    return getConcreteUrl(user, cycle.type, cycle);
}

export function getPageTitle(mode, model, singularTitleKey, initialModelName = model.name) {
    const defaultPageTitle = {
        [MODES.copy]: initialModelName,
        [MODES.create]: `${replacement(singularTitleKey)} Cycle Setup`,
        [MODES.edit]: `Edit ${initialModelName}`,
    }[mode];
    const isNameEdited = model.name !== initialModelName;

    if (isNameEdited && model.name) {
        return model.name;
    }

    return defaultPageTitle;
}

export function getInitialStaffSelection(mode) {
    if (mode === MODES.copy) {
        return 'STAFF_SELECTION_SELECTED_STAFF';
    } else {
        return undefined;
    }
}

function getConcreteUrl(user, type, cycle) {
    const userHasBasicHr = hasBasicHr(user);

    switch (type) {
        case FEEDBACK:
            return userHasBasicHr
                ? interpolateAppUrl(R.ADMIN_FEEDBACK_WITH_CYCLE, {
                      cycleId: cycle.id,
                  })
                : interpolateAppUrl(R.FEEDBACK_USER_TEAM_SINGLE_CYCLE, {
                      cycleId: cycle.id,
                      managerId: user.id,
                  });
        case REVIEW:
            return userHasBasicHr
                ? interpolateAppUrl(R.ADMIN_REVIEWS_WITH_CYCLE, {
                      cycleId: cycle.id,
                  })
                : interpolateAppUrl(R.REVIEWS_TEAM_CYCLE, {
                      cycleId: cycle.id,
                      managerId: user.id,
                  });
        case OBJECTIVE:
            return userHasBasicHr
                ? interpolateAppUrl(R.ADMIN_OBJECTIVES_CYCLE_OVERVIEW, { cycleId: cycle.id })
                : getObjectiveUrlForNonHr(user, cycle);
    }
}

function getObjectiveUrlForNonHr(user, cycle) {
    return isManager(user)
        ? interpolateAppUrl(R.OBJECTIVES_TEAM_CYCLE, {
              cycleId: cycle.id,
              managerId: user.id,
          })
        : '/app/team/objectives/browse?select=coworkers&cycleIds=' + cycle.id;
}
